// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j6-2";
export var container = "_j6-4";
export var dismissButton = "_j6-3";
export var hasPaddingBottom = "_j6-6";
export var last = "_j6-e";
export var scrollbarThumb = "_j6-c";
export var scrollbarTrack = "_j6-b";
export var selected = "_j6-9";
export var spin = "_j6-1";
export var spinning = "_j6-0";
export var suggestionItem = "_j6-d";
export var suggestionsPanel = "_j6-5";
export var tonePill = "_j6-8";
export var tonesContainer = "_j6-7";
export var unselected = "_j6-a";